function useIsVideo(attachment?: string) {
  if (!attachment) return {
    isVideo: false,
    isBase64: false
  }

  // return (() => {
  //   for (let i = attachmentURL.length; i > 0; i--) {
  //     if (attachmentURL[i] === ".") {
  //       const extension = attachmentURL.slice(i + 1)
  //       return (
  //         extension === "mp4" ||
  //         extension === "webm" ||
  //         extension === "quicktime" ||
  //         extension === "mov"
  //       )
  //     }
  //   }
  // })()

  // Regular expression to check for video file extensions
  const fileExtensionRegex = /\.(mp4|webm|quicktime|mov)$/i;

  // Regular expression to check for base64 data URLs with video MIME types
  const base64VideoRegex = /^data:video\/[^;]+;base64,/i;

  // Regular expression to check for base64 data URLs
  const base64DataURLRegex = /^data:[a-zA-Z0-9+.-]+\/[a-zA-Z0-9+.-]+;base64,/i;


  return {
    isVideo: fileExtensionRegex.test(attachment) || base64VideoRegex.test(attachment),
    isBase64: base64DataURLRegex.test(attachment)
  };

}

export function useIsVideoMimeType(mimeType: string) {
  if (
    mimeType === "mp4" ||
    mimeType === "webm" ||
    mimeType === "quicktime" ||
    mimeType === "mov" ||
    mimeType.split("/").at(-1) === "mp4" ||
    mimeType.split("/").at(-1) === "webm" ||
    mimeType.split("/").at(-1) === "quicktime" ||
    mimeType.split("/").at(-1) === "mov"
  ) {
    return true
  }
  return false
}

export default useIsVideo
